import { Observer, observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { toJS } from 'mobx'
import ChevronDownIcon from '@ui-components-3/icons/lib/regular/ChevronDown'
import VisitCardsExpansion from 'singletons/VisitCardsExpansion'
import User from 'singletons/User' // Assuming User singleton provides licenses
import { VisitTypes, isSuccessVisit } from '../../../../../constants/visit-types'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

interface ViewDetailsButtonProps {
  visit: any
  buttonSize?: 'btn-md' | 'btn-small'
  buttonType?: 'btn-primary' | 'btn-primary-outlined'
}

const ViewDetailsButton = ({ visit, buttonSize = 'btn-md', buttonType = 'btn-primary' }: ViewDetailsButtonProps) => {
  const { visitType, pendingVisitId } = visit || {}

  const plainProviderLicenses = toJS(User.provider.licenses)

  const isDisabled = useMemo(() => {
    if (
      plainProviderLicenses &&
      plainProviderLicenses.length === 1 &&
      plainProviderLicenses[0] &&
      plainProviderLicenses[0].type === VisitTypes.success
    ) {
      return !isSuccessVisit(visitType)
    }
    return false
  }, [plainProviderLicenses, visitType])

  if (!visit) {
    return null
  }

  return (
    <Observer>
      {() => {
        const expanded = VisitCardsExpansion.expanded(pendingVisitId)

        return (
          <button
            className={classNames(buttonSize, buttonType)}
            onClick={() => {
              VisitCardsExpansion.toggle(pendingVisitId)
              if (visit.checkIfExtendedRecordExists) {
                visit.checkIfExtendedRecordExists()
              }
            }}
            type="button"
            disabled={isDisabled}
          >
            {expanded ? 'Hide details' : 'View details'}
            <ChevronDownIcon
              style={{
                transform: `rotate(${expanded ? 180 : 0}deg)`,
              }}
              aria-hidden="true"
              className={buttonSize === 'btn-small' ? '!mr-0' : ''} // Special handling for small buttons in RxChange
            />
          </button>
        )
      }}
    </Observer>
  )
}

export default observer(ViewDetailsButton)
